import {
  REPORT_ONLY_LAYOUT,
  COVER_AND_REPORT_LAYOUT,
  SUMMARY_LAYOUT,
  OFFICIAL_REPORT,
  UNOFFICIAL_REPORT,
  QC_LAYOUT,
  REPORT_DISPLAY_NAMES,
} from '../constants/reportLayouts';
import { TYPE } from '../constants/layoutManagement';

const _isValueExist = (options, value) => {
  return Boolean(options.find((option) => option.value === value));
};

const _getBasicOptions = () => {
  return [
    { label: REPORT_DISPLAY_NAMES[COVER_AND_REPORT_LAYOUT], value: COVER_AND_REPORT_LAYOUT },
    { label: REPORT_DISPLAY_NAMES[REPORT_ONLY_LAYOUT], value: REPORT_ONLY_LAYOUT },
    { label: REPORT_DISPLAY_NAMES[SUMMARY_LAYOUT], value: SUMMARY_LAYOUT },
  ];
};

const _getOfficialOptions = (isTestValid) => {
  const options = [];

  if (isTestValid === 'Yes') {
    options.push({ label: REPORT_DISPLAY_NAMES[OFFICIAL_REPORT], value: OFFICIAL_REPORT });
  }
  if (isTestValid === 'No') {
    options.push({ label: REPORT_DISPLAY_NAMES[UNOFFICIAL_REPORT], value: UNOFFICIAL_REPORT });
  }

  return options;
};

const _getCommonOptions = (isQcTest) => {
  const options = [];

  if (isQcTest) {
    options.push({ label: REPORT_DISPLAY_NAMES[QC_LAYOUT], value: QC_LAYOUT });
  }

  return options;
};

export const getBasicTestOptions = ({ isQcTest = false }) => {
  return [..._getBasicOptions(), ..._getCommonOptions(isQcTest)];
};

export const getDynamicTestOptions = (layoutType, { isTestValid, isQcTest = false }) => {
  return [
    ...(layoutType === TYPE.BASIC && _getBasicOptions()),
    ...(layoutType === TYPE.OFFICIAL && _getOfficialOptions(isTestValid)),
    ..._getCommonOptions(isQcTest),
  ];
};

export const getValue = (options, defaultValue) => {
  return _isValueExist(options, defaultValue) ? defaultValue : options[0] && options[0].value;
};



// WEBPACK FOOTER //
// src/utils/reportLayoutDropdown.js